/* eslint-disable @nx/enforce-module-boundaries */
import { VisibilityIcon } from '@mybridge/icons';
import {
  HStack,
  Heading,
  Input,
  Link,
  Spinner,
  Stack,
  Switch,
  Text,
} from '@mybridge/ui';
import { forwardRef, useContext, useEffect } from 'react';
import { MyProfileContext } from '../context';
import { FileInput } from '@mybridge/ui/file-upload';
import styles from './visibility.module.scss';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
export const MyProfileVisibility = forwardRef(({ ...props }, ref) => {
  const {
    jobPreferences,
    refetchJobPreferences,
    userProfileInfo,
    updateJobPreferences,
    updateProfile,
    updateJobPreferencesLoading,
    removeResume,
  } = useContext(MyProfileContext);
  const { t } = useTranslator();
  useEffect(() => {
    refetchJobPreferences?.();
  }, []);

  const {
    job_availabilty,
    job_alert,
    file_visibility,
    resume_first,
    resume_second,
    resume_first_name,
    resume_second_name,
  } = jobPreferences ?? {};

  const { is_visible } = userProfileInfo ?? {};

  const onBioVisibilityChange = async (e) => {
    await updateJobPreferences({
      job_availabilty: 1,
      job_alert: true,
      file_visibility: e?.target?.checked ? 'True' : 'False',
    });
  };

  const uploadResumeFirst = async (e) => {
    const file = e?.target?.files?.[0];
    if (file) {
      await updateJobPreferences({
        job_availabilty: 1,
        job_alert: true,
        resume_first: file,
      });
    }
  };

  const uploadResumeSecond = async (e) => {
    const file = e?.target?.files?.[0];
    if (file) {
      await updateJobPreferences({
        job_availabilty: 1,
        job_alert: true,
        resume_second: file,
      });
    }
  };

  const onProfileVisibilityChange = async (e) => {
    await updateProfile({
      is_visible: e?.target?.checked,
    });
  };

  return (
    <Stack>
      <HStack>
        {updateJobPreferencesLoading ? (
          <Spinner />
        ) : (
          <VisibilityIcon color="#3D5A80" />
        )}
        <Heading fontSize="18px" fontWeight="400" color="#3D5A80">
          {t('profile.editVisibility') || "Edit Visibility"}
        </Heading>
      </HStack>
      <HStack>
        <Text flex={1} fontSize="15px" fontWeight={400} color="#5B5B5B">
          {t('profile.publicProfileVisibility') || "Your profile’s public visibility"}
        </Text>
        <Switch onChange={onProfileVisibilityChange} isChecked={is_visible} />
      </HStack>
      <HStack>
        <Text flex={1} fontSize="15px" fontWeight={400} color="#5B5B5B">
          {t('profile.myBioPDF') || "myBio in PDF"}
        </Text>
        <Switch
          onChange={onBioVisibilityChange}
          isChecked={jobPreferences?.file_visibility}
        />
      </HStack>
      {jobPreferences?.file_visibility ? (
        <>
          <Stack>
            {resume_first?.length ? (
              <HStack>
                <Link
                  as={Text}
                  href={resume_first}
                  // textDecoration="underline dashed"
                  truncate
                  maxW="150px"
                  target={'_blank'}
                >
                  {resume_first_name}
                </Link>
                <HStack flex={1} justifyContent="flex-end">
                  <Link fontSize="12px" color="red" onClick={(e) => removeResume('first', true)}>
                    {t('profile.remove') || "Remove"}
                  </Link>
                </HStack>
              </HStack>
            ) : (
              <>
                <Text fontSize="13px">
                  {t('profile.acceptedFiles') || "Only pdf, doc, docx and ppt files accepted."}
                </Text>
                {/* <Input
                  isDisabled={updateJobPreferencesLoading}
                  accept=".doc,.docx,.pdf,.ppt"
                  onChange={uploadResumeFirst}
                  bg="transparent"
                  border="none"
                  p={0}
                  type="file"
                /> */}
                <FileInput
                  className={styles.fileInput}
                  variant="defaultInputFile"
                  onChange={uploadResumeFirst}
                  size="lg"
                  accept=".doc,.docx,.pdf,.ppt,.pptx"
                  pl={0}
                />
              </>
            )}
          </Stack>
          <Stack>
            {resume_second?.length ? (
              <>
                <HStack>
                  <Link
                    as={Text}
                    href={resume_second}
                    // textDecoration="underline dashed"
                    truncate
                    maxW="150px"
                    target={'_blank'}
                  >
                    {resume_second_name}
                  </Link>
                  <HStack flex={1} justifyContent="flex-end">
                    <Link fontSize="12px" color="red" onClick={(e) => removeResume('second', true)}>
                      {t('profile.remove') || "Remove"}
                    </Link>
                  </HStack>
                </HStack>
              </>
            ) : (<>
            
              {resume_first?.length&&<>
                <Text fontSize="13px">
                  {t('profile.acceptedFiles') || "Only pdf, doc, docx and ppt files accepted."}
                </Text>
                {/* <Input
                  isDisabled={updateJobPreferencesLoading}
                  accept=".doc,.docx,.pdf,.ppt"
                  bg="transparent"
                  border="none"
                  p={0}
                  type="file"
                  onChange={uploadResumeSecond}
                /> */}
                <FileInput
                  className={styles.fileInput}
                  variant="defaultInputFile"
                  onChange={uploadResumeSecond}
                  size="lg"
                  accept=".doc,.docx,.pdf,.ppt,.pptx"
                  pl={0}
                  />
              </>}
                  </>
            )}
          </Stack>
        </>
      ) : (
        ''
      )}
    </Stack>
  );
});
